import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

var emergencyvalues = {
    appraisal: 'Error', 
    applicationname: 'Error',
    status: 'error'
}

export const store = new Vuex.Store({
    
    state: {
        settings: {},
        appraisals: [],
        currentappraisal: {},
        gotdetails: false,
    },
        
    actions: {
        init(context) {
            console.log('Loading data from server...')

            axios
                .get("/api/all")
                .then((response) => {
                    if (response.status == 200) {
                        console.info("Loaded");
                        context.state.settings = response.data.settings;
                        context.state.appraisals = response.data.appraisals;
                        context.state.gotdetails = true;
                    } else {
                        console.log("Error");
                        context.state.settings = emergencyvalues;
                        context.state.gotdetails = false;
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log('Unable to retrieve settings' + error)
                    context.state.settings = emergencyvalues
                    context.state.gotdetails = false;
                })
        },
    },

    getters: {
        settings: state => state.settings,
        appraisals: state => state.appraisals,
        currentappraisal: state => state.currentappraisal,
        gotdetails: state => state.gotdetails,
    },

    mutations: {
        setcurrentappraisal (state, obj) {
            state.currentappraisal = obj
        },
        
    }
})
